<template>
  <section class="w-full px-2 mb-4 wrapper-bar-chart">
    <div class="flex flex-col justify-between pb-4 border-b">
      <h1 class="mb-2 md:text-xl">Attendance & Leave Statistic</h1>
      <div class="mt-2 text-xs text-end">
        <span
          class="mr-2 cursor-pointer"
          :class="
            selectedFilter === 'by_late' ? 'text-blue-500' : 'text-gray-500'
          "
          @click="$emit('on-selected-filter', 'by_late')"
        >
          By late ranking
        </span>
        <span
          class="mr-2 cursor-pointer"
          :class="
            selectedFilter === 'by_absent' ? 'text-blue-500' : 'text-gray-500'
          "
          @click="$emit('on-selected-filter', 'by_absent')"
        >
          By absent rangking
        </span>
        <span
          class="mr-2 cursor-pointer"
          :class="
            selectedFilter === 'off_day' ? 'text-blue-500' : 'text-gray-500'
          "
          @click="$emit('on-selected-filter', 'off_day')"
        >
          to day (Off day)
        </span>
        <span
          class="mr-2 cursor-pointer"
          :class="
            selectedFilter === 'leave_request'
              ? 'text-blue-500'
              : 'text-gray-500'
          "
          @click="$emit('on-selected-filter', 'leave_request')"
        >
          to day (Leave request)
        </span>
        <span
          class="cursor-pointer"
          :class="
            selectedFilter === 'leave_today' ? 'text-blue-500' : 'text-gray-500'
          "
          @click="$emit('on-selected-filter', 'leave_today')"
        >
          to day (Leave today)
        </span>
      </div>
    </div>
    <section class="w-full verflow-x-auto custom-scrollbar">
      <table class="w-full pb-4 mt-1 min-w-max">
        <thead class="text-gray-400 border-b border-gray-200">
          <tr>
            <th class="text-sm text-left">Profile</th>
            <th class="text-sm text-left">Total</th>
          </tr>
        </thead>
        <tbody v-if="!isLoading">
          <tr
            class="border-b h-max"
            v-for="(attendanceLeave, index) in attendanceLeaveStatistics"
            :key="index"
          >
            <td class="p-3 text-sm">
              <div class="flex flex-row items-center gap-x-2">
                <div
                  class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400"
                >
                  <h2 class="text-white text-md">
                    {{ avatarEmployee(attendanceLeave.employee.emp_fullname) }}
                  </h2>
                </div>
                <div class="flex flex-col">
                  <p class="text-sm text-blue-500">
                    {{ attendanceLeave.employee.emp_fullname }}
                  </p>
                  <p class="text-sm text-gray-400">
                    {{ attendanceLeave.employee.emp_depid.dep_name }}
                  </p>
                </div>
              </div>
            </td>
            <td class="text-sm">{{ attendanceLeave.total }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td>Loading ...</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="!isLoading && attendanceLeaveStatistics.length"
        :current="meta && meta.currentPage ? meta.currentPage : page"
        :total="meta && meta.total ? meta.total : attendanceLeaveStatistics.length"
        :per-page="limit"
        @page-changed="pageChanged"
      />
    </section>
  </section>
</template>

<script>
import Pagination from "@ocrv/vue-tailwind-pagination";
import "@ocrv/vue-tailwind-pagination/styles";

export default {
  name: "AttendanceLeaveStatistic",
  components: {
    Pagination,
  },
  props: {
    attendanceLeaveStatistics: {
      type: Array,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    selectedFilter: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    avatarEmployee(employeeFullname) {
      return (
        employeeFullname.substr(0, 1) +
        employeeFullname.substr(employeeFullname.indexOf(" ") + 1, 1)
      );
    },
    pageChanged(event) {
      this.$emit("on-pagination", event);
    },
  },
};
</script>
